<template>
  <PackageDetail :id="id" />
</template>

<script>
import PackageDetail from '@/components/student/PackageDetail'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    PackageDetail
  }
}
</script>
